/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbAdmissionCoordinatorSummary } from './HchbAdmissionCoordinatorSummary';
import {
    HchbAdmissionCoordinatorSummaryFromJSON,
    HchbAdmissionCoordinatorSummaryFromJSONTyped,
    HchbAdmissionCoordinatorSummaryToJSON,
} from './HchbAdmissionCoordinatorSummary';

/**
 * 
 * @export
 * @interface HchbAdmissionCoordinatorPage
 */
export interface HchbAdmissionCoordinatorPage {
    /**
     * 
     * @type {Array<HchbAdmissionCoordinatorSummary>}
     * @memberof HchbAdmissionCoordinatorPage
     */
    data: Array<HchbAdmissionCoordinatorSummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbAdmissionCoordinatorPage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbAdmissionCoordinatorPage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbAdmissionCoordinatorPage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbAdmissionCoordinatorPage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbAdmissionCoordinatorPage interface.
 */
export function instanceOfHchbAdmissionCoordinatorPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function HchbAdmissionCoordinatorPageFromJSON(json: any): HchbAdmissionCoordinatorPage {
    return HchbAdmissionCoordinatorPageFromJSONTyped(json, false);
}

export function HchbAdmissionCoordinatorPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbAdmissionCoordinatorPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbAdmissionCoordinatorSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbAdmissionCoordinatorPageToJSON(value?: HchbAdmissionCoordinatorPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbAdmissionCoordinatorSummaryToJSON)),
        'page': value.page,
        'limit': value.limit,
        'total': value.total,
        'has_next': value.has_next,
    };
}

